import { connect, useDispatch } from "react-redux";
import { IStudentTransactionDetails } from "../../../../models/student/studentAccountsDetails";
import { useEffect } from "react";
import { setStudentTransactionInfo } from "../../../../store/slices/student/studentTransactions";
import { getStudentTransactionDetail } from "../../../../action/student/studentAccountDetailsActionCreator";
import { apiConfig } from "../../../../constants/apiConfig";

const StudentTransactions = (props: IStudentTransactionDetails) => {
  const { getAllTransactions, allTransactions } = props;

  const viewAllUrl = apiConfig.studentTransactionsUrl

  const dispatch = useDispatch();

  useEffect(() => {
    getAllTransactions(8);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setStudentTransactionInfo([]));
    };
  }, []);
  

  return (
    <>
      <div className="title">
        <h2>Transactions</h2>
        <a
          href={viewAllUrl}
          className="btn-link"
          target="_blank"
        >
          View All
        </a>
      </div>
      <ul className="transactions-wrap stud-transaction transactions-scroll mt-3">
        {allTransactions?.map((Transaction) => (
          <li className="pe-none">
            <div className="icon">
              <img src= {Transaction.image} />
            </div>
            <div>
              <h3>{Transaction.title}</h3>
              <p>{Transaction.description}</p>
            </div>
            <h6
              className={
                Transaction.amount > 0 ? "text-success" : "text-danger"
              }
            >
              {Transaction.amount >= 0
                ? "+" + Transaction.amount
                : "-" + Transaction.amount * -1}
            </h6>
          </li>
        ))}
      </ul>
    </>
  );
};

const mapDispatchToProps = {
  getAllTransactions: (noOfItems?: number) =>
    getStudentTransactionDetail(noOfItems),
};

function mapStateToProps(state: any) {
  return {
    allTransactions: state.studentTransactionDetails.TransactionDetail,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentTransactions);
